import { atom } from 'jotai';
import type { AgentApiProfitsItem } from '@/types/serializers';

export const currentSelectProfitAtom = atom<AgentApiProfitsItem | null>(null);
